<div class="modal-header px-4 justify-content-between">
  <h4 class="modal-title header-13">
    {{ title }}
  </h4>
  <div>
    <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="activeModal.dismiss('Cross click')"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        "
        alt="Close"
      />
    </button>
  </div>
</div>

<div class="my-3 px-4 cmd-rest">
  <!-- Service/operation selection -->
  <div class="sec-1 row">
    <div class="col-md-6">
      <span class="form-label"> Services </span>
      <select [(ngModel)]="data.service" class="form-select mt-1" (change)="selectService()">
        <option disabled selected value="">Select service</option>
        <option *ngFor="let service of services" [value]="service.value"> {{ service.label }} </option>
      </select>
    </div>
    <div class="col-md-6">
      <span class="form-label">
        Operations
        <span *ngIf="isOperationLoading" class="spinner-border spinner-border-sm mx-2" role="status"
          aria-hidden="true">
        </span>
        <span class="opr-label" [hidden]="isOperationLoading">
          {{ operationLoaderText }}
        </span>
      </span>
      <select [(ngModel)]="data.operation"  (ngModelChange)="onOperationChange($event)" [disabled]="!data.service" class="form-select mt-1">
        <option disabled selected value="">Select operation</option>
        <option *ngFor="let operation of operations" [value]="operation.value"> {{ operation.label }} </option>
      </select>
    </div>
  </div>

  <!-- Parameters table -->
  <div class="sec-2">
    <div class="d-flex mb-2 mt-4">
        <span class="v-center form-label mb-0"> Parameters </span>
        <div class="d-flex add-btn mx-4" (click)="addParam()" (keydown)="addParam()">
            <img src="assets/images/virtusa-icons/add-icon.svg" alt="add" class="mx-1">
            <span class="v-center"> Add New Parameter </span>
        </div>
    </div>
    <app-zorro-table
      tableId="rest-params"
      class="w-100"
      [columns]="paramTable.columns"
      [data]="paramTable.rows"
      [autocompleteOptions]="autocompleteOptionsByKey"
      (handleActions)="handleParamTableActions($event)"
    ></app-zorro-table>
  </div>

  <!-- Headers table -->
  <div class="sec-3">
    <div class="d-flex mb-2 mt-4">
        <span class="v-center form-label mb-0"> Headers </span>
        <div class="d-flex add-btn mx-4" (click)="addHeader()" (keydown)="addHeader()">
            <img src="assets/images/virtusa-icons/add-icon.svg" alt="add" class="mx-1">
            <span class="v-center"> Add New Header </span>
        </div>
    </div>
    <app-zorro-table
      tableId="rest-headers"
      class="w-100"
      [columns]="headerTable.columns"
      [data]="headerTable.rows"
      [autocompleteOptions]="autocompleteOptionsByKey"
      (handleActions)="handleHeaderTableActions($event)"
    ></app-zorro-table>
  </div>

  <!-- Variable/other field options -->
  <div class="sec-4 d-flex">
    <div class="col-md-6 mt-3">
        <span class="form-label"> Variable Name </span>
        <select [(ngModel)]="data.variable" class="form-select mt-1">
          <option *ngFor="let opt of variableList" [value]="opt.name"> {{ opt.name }} </option>
        </select>
        <!-- <input [(ngModel)]="data.variable" class="form-control mt-1" type="text" placeholder="Enter variable name"> -->
      </div>
      <div class="col-md-6 d-flex pt-3 mx-5">
        <span class="check-label v-center mx-1 mt-4"> Report Failures </span>
        <input [(ngModel)]="data.isReportFailure" type="checkbox" class="min-width-unset mt-4 mx-1">
      </div>
  </div>
</div>

<div class="modal-footer">
  <div class="d-flex justify-content-end">
    <button
      class="btn-accello-secondary mx-2 open-btn"
      (click)="activeModal.dismiss('Cross click')"
    >
      Cancel
    </button>
    <button class="btn-accello-primary-light open-btn" (click)="addCommand()" [disabled]="!data.service || !data.operation || !data.variable">
      {{ isEdit ? 'Update' : 'Add' }}
    </button>
  </div>
</div>
